import { postCampaign, getCampaign, getCampaigns, updateCampaign, deleteCampaign, getCSVInfo, launchCampaign, notifySale } from './campaigns'

import {
  postTemplate, getTemplate, getAllTemplates, postPublishTemplate, updateTemplate,
  deleteTemplate, getTemplateVariables, filterChannelsTemplate, addChannelsTemplate, getChatTemplates
} from './templates'

import { getFilters } from './filters'

import { getTickets, getAdvancedFilteredTickets } from './tickets'

export default {
  postCampaign,
  getCampaign,
  getCampaigns,
  updateCampaign,
  deleteCampaign,
  launchCampaign,
  getCSVInfo,

  postTemplate,
  getTemplate,
  getAllTemplates,
  getChatTemplates,
  updateTemplate,
  deleteTemplate,
  getTemplateVariables,
  postPublishTemplate,
  filterChannelsTemplate,
  addChannelsTemplate,

  getFilters,
  getTickets,
  getAdvancedFilteredTickets,

  notifySale,
}
